import { useQuery } from '@tanstack/react-query';

import {
  ApiResponseWithMethods,
  queryResultToApiResponse,
} from './ApiResponse';

function fetchConfig(): unknown {
  const host = window.location.origin;

  return fetch(`${host}/config.json`).then((res) => res.json());
}

export function useConfig(): ApiResponseWithMethods<unknown, unknown> {
  const result = useQuery({
    queryKey: [],
    queryFn: fetchConfig,
    staleTime: Infinity,
  });

  return queryResultToApiResponse(result);
}
